import * as React from "react";
import type { SVGProps } from "react";
const SvgCopyLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M18 9.6h2.4a1.2 1.2 0 0 1 1.2 1.2v8.8a2 2 0 0 1-2 2h-8.8a1.2 1.2 0 0 1-1.2-1.2V18M12 2.4H4.8a2.4 2.4 0 0 0-2.4 2.4V12a2.4 2.4 0 0 0 2.4 2.4H12a2.4 2.4 0 0 0 2.4-2.4V4.8A2.4 2.4 0 0 0 12 2.4Z"
    />
  </svg>
);
export default SvgCopyLeft;
